import { styled, keyframes } from '../../../stitches.config';

const pulse = keyframes({
  '0%': { backgroundPosition: '20% 50%' },
  '50%': { backgroundPosition: '80% 50%' },
  '100%': { backgroundPosition: '20% 50%' },
});

const BODY_BACKGROUND_HEXAGON_SIZE = 50;
const COLOR1 = 'green';
const COLOR2 = 'purple';

export const Skeleton = styled('div', {
  'height': '100%',
  'position': 'relative',
  'overflow': 'hidden',
  '&::before': {
    content: '',
    zIndex: 1,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    background: `linear-gradient(45deg, $${COLOR1}5, $slate3, $${COLOR2}5)`,
    backgroundSize: '300% 300%',
    animation: `${pulse} 4000ms infinite`,
  },
  '&::after': {
    content: '',
    zIndex: 2,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='100%25' width='100%25'%3E%3Cdefs%3E%3Cpattern id='doodad' width='${
      BODY_BACKGROUND_HEXAGON_SIZE * 1.1547
    }' height='${BODY_BACKGROUND_HEXAGON_SIZE}' viewBox='0 0 34.64101615137755 30' patternUnits='userSpaceOnUse' patternTransform='rotate(135)'%3E%3Crect width='100%25' height='100%25' fill='rgba(247, 250, 252,0)'/%3E%3Cpath d='M-20-20h200v200h-200M34.21 25.25L25.98 20.5L17.75 25.25L17.75 34.75L25.98 39.5L34.21 34.75zM16.89 25.25L8.66 20.5L0.43 25.25L0.43 34.75L8.66 39.5L16.89 34.75zM8.23 10.25L0 5.5L-8.23 10.25L-8.23 19.75L0 24.5L8.23 19.75zM16.89-4.75L8.66-9.5L0.43-4.75L0.43 4.75L8.66 9.5L16.89 4.75zM34.21-4.75L25.98-9.5L17.75-4.75L17.75 4.75L25.98 9.5L34.21 4.75zM42.87 10.25L34.64 5.5L26.41 10.25L26.41 19.75L34.64 24.5L42.87 19.75zM25.55 10.25L17.32 5.5L9.09 10.25L9.09 19.75L17.32 24.5L25.55 19.75z' fill='black'/%3E%3Cpath d='M-20-20h200v200h-200M24.21 25.25L15.98 20.5L7.75 25.25L7.75 34.75L15.98 39.5L24.21 34.75zM6.89 25.25L-1.34 20.5L-9.57 25.25L-9.57 34.75L-1.34 39.5L6.89 34.75zM-1.77 10.25L-10 5.5L-18.23 10.25L-18.23 19.75L-10 24.5L-1.77 19.75zM6.89-4.75L-1.34-9.5L-9.57-4.75L-9.57 4.75L-1.34 9.5L6.89 4.75zM24.21-4.75L15.98-9.5L7.75-4.75L7.75 4.75L15.98 9.5L24.21 4.75zM32.87 10.25L24.64 5.5L16.41 10.25L16.41 19.75L24.64 24.5L32.87 19.75zM41.53 25.25L33.3 20.5L25.07 25.25L25.07 34.75L33.3 39.5L41.53 34.75zM15.55 40.25L7.32 35.5L-0.91 40.25L-0.91 49.75L7.32 54.5L15.55 49.75zM-10.43 25.25L-18.66 20.5L-26.89 25.25L-26.89 34.75L-18.66 39.5L-10.43 34.75zM-10.43-4.75L-18.66-9.5L-26.89-4.75L-26.89 4.75L-18.66 9.5L-10.43 4.75zM15.55-19.75L7.32-24.5L-0.91-19.75L-0.91-10.25L7.32-5.5L15.55-10.25zM41.53-4.75L33.3-9.5L25.07-4.75L25.07 4.75L33.3 9.5L41.53 4.75zM32.87 40.25L24.64 35.5L16.41 40.25L16.41 49.75L24.64 54.5L32.87 49.75zM-1.77 40.25L-10 35.5L-18.23 40.25L-18.23 49.75L-10 54.5L-1.77 49.75zM-19.09 10.25L-27.32 5.5L-35.55 10.25L-35.55 19.75L-27.32 24.5L-19.09 19.75zM-1.77-19.75L-10-24.5L-18.23-19.75L-18.23-10.25L-10-5.5L-1.77-10.25zM32.87-19.75L24.64-24.5L16.41-19.75L16.41-10.25L24.64-5.5L32.87-10.25zM50.19 10.25L41.96 5.5L33.73 10.25L33.73 19.75L41.96 24.5L50.19 19.75zM15.55 10.25L7.32 5.5L-0.91 10.25L-0.91 19.75L7.32 24.5L15.55 19.75z' fill='rgba(236, 201, 75,0)'/%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23doodad)' height='200%25' width='200%25'/%3E%3C/svg%3E ")`,
    mixBlendMode: 'overlay',
  },
});
